import type { LifeInsuranceFormInput } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";

export const LIFE_INSURANCE_FORM_DEFAULT_VALUES: LifeInsuranceFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	productCategoryId: null,
	signedAt: null,
	startAt: null,
	endAt: null,
};
